<template>
  <div class="journeyInvoice">
    <Nav :title="title"></Nav>
    <div class="loading" v-if="isLoad" :style="{'height':winHeight+'px'}">
        <img src="./../../assets/takingCar/loading.gif" alt="" />
      </div>
    <div class="content" :class="{ isIosx: isiOSX }" id="content">
      
      <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
      <van-list class="allList">
        <div
          class="list"
          v-for="(item, index) in list"
          :key="index"
          @click="select(item, index)"
        >
          <div
            class="left checkimg"
            :class="{ ncheckimg: item.selected }"
          ></div>
          <div class="right">
            <p class="title">
              {{ item.platform_name.substring(0, 2) }}{{ item.car_type_name }}
              <span>{{ item.created_at | timeFormat }}</span>
            </p>
            <p class="cfd">
              <img src="./../../assets/takingCar/qsd.png" alt />
              <span>{{ item.start_position }}</span>
              <img
                src="./../../assets/takingCar/middash.png"
                alt=""
                class="middash"
              />
            </p>
            <div class="mdd">
              <p class="mddp">
                <img src="./../../assets/takingCar/zd.png" alt />
                <span>{{ item.end_address }}</span>
              </p>
              <p class="mddright">
                <span class="money">{{ item.invoiced_amount | moneyFormat }}</span>
                <span>元</span>
              </p>
            </div>
          </div>
        </div>
      </van-list>
      <!-- </van-pull-refresh> -->
    </div>

    <div class="foot">
      <div class="button">
        <div @click="checkAll()">
          <img
            src="./../../assets/takingCar/unchecked.png"
            alt
            v-show="!ischeckAll"
          />
          <img
            src="./../../assets/takingCar/checked.png"
            alt
            v-show="ischeckAll"
          />
          <span>全选</span>
        </div>
        <button
          @click="goToSeeDetail"
          :class="checkedArr.length == 0 ? 'bannedClick' : ''"
        >
          下一步
        </button>
      </div>
    </div>

    <!-- //没数据时显示 -->
    <van-row class="empty" v-if="this.list.length < 1 && !isLoad">
      <van-col class="emptyMsg" span="24">
        <p class="tip1">当前暂无行程～</p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "按照行程开票",
      isiOSX: false,
      //   下拉刷新
      isLoading: false, //加载中
      // page: 1,
      ischeckAll: false,
      list: [
        // {
        //   carname: "曹操新能源",
        //   time: "2020-03-20 星期六 15:36",
        //   cfd: "泛海国际中心东门",
        //   mdd: "杭州东站(东1门)",
        //   money: "25.01"
        // }
      ],
      checkedArr: [],
      loading: false,
      finished: false,
      page: 1, //请求第几页
      total: 0, //总共的数据条数
      itemList: [],
      isLoad: true,
      winHeight:0
    };
  },
  filters: {
    timeFormat(str) {
      var mydate = new Date(str.replace(/-/g, "/"));
      var myddy = mydate.getDay(); //获取存储当前日期
      var weekday = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      return (
        str.substring(0, 10) +
        " " +
        weekday[myddy] +
        " " +
        str.substring(10, 16)
      );
    },
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
  },
  components: { Nav },
  created() {
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.isiOSX = this.isIphoneX();
    this.getJourneyList();
    this.daraFormatting();
    this.winHeight = document.documentElement.clientHeight; //浏览器视口大小
  },
  methods: {
    // 格式化数据，添加selected属性，控制是否选中样式
    daraFormatting() {
      this.list.forEach((item) => {
        item.selected = false;
      });
    },
    // 下拉刷新
    // onRefresh() {
    //   // console.log("下拉刷新");
    //   this.page = 1;
    //   this.finished = false;
    //   this.getJourneyList(1);
    // },
    // 选择
    select(item, index) {
      let startTime = item.created_at.replace(/-/g, "/");
      let endTime = new Date();
      //获取时间戳
      var startTimestamp = new Date(startTime).getTime();
      var endTimestamp = new Date(endTime).getTime();

      if (endTimestamp > startTimestamp) {
        if (endTimestamp - startTimestamp <= 2 * 365 * 24 * 60 * 60 * 1000) {
          // console.log("两年内");
          item.selected = !item.selected;
          this.list = [...this.list];
          if (item.selected) {
            this.checkedArr.push(item);
          } else {
            // console.log('取消')
            // 取消选中，判断数组中是否已选，存在则删除
            let num = this.checkedArr.indexOf(item);
            if (num > -1) {
              this.checkedArr.splice(num, 1);
            }
          }
          if (this.checkedArr.length == this.list.length) {
            this.ischeckAll = true;
          } else {
            this.ischeckAll = false;
          }
        } else {
          // console.log("超过两年");
          this.$toast("行程已超过有效期，不可开票");
        }
      }
    },
    // 全选
    checkAll() {
      this.ischeckAll = !this.ischeckAll;
      if (this.ischeckAll) {
        //全选
        this.list.forEach((item) => {
          let startTime = item.created_at.replace(/-/g, "/");
          let endTime = new Date();
          //获取时间戳
          var startTimestamp = new Date(startTime).getTime();
          var endTimestamp = new Date(endTime).getTime();
          if (endTimestamp > startTimestamp) {
            if (
              endTimestamp - startTimestamp <=
              2 * 365 * 24 * 60 * 60 * 1000
            ) {
              item.selected = true;
              this.checkedArr.push(item);
            } else {
              this.$toast("其中有行程已超过有效期，不可开票");
            }
          }
        });
      } else {
        //取消全选
        this.list.forEach((item) => {
          item.selected = false;
        });
        this.checkedArr = [];
      }

      this.list = [...this.list];
    },
    // 获取行程列表
    getJourneyList(type) {
      this.$api.post("taxis/member/invoice/trip/list").then((res) => {
        this.isLoad = false;
        // console.log(res);
        res.forEach(item =>{
          if(item.short_name != 'T3'){
            this.list.push(item)
          }
        })
        // this.list = res;
      });
    },
    //滚动加载时触发，list组件定义的方法
    // onLoad() {
    //   // console.log("加载更多");
    //   this.page++;
    //   this.getJourneyList(2);
    // },
    // 提交
    goToSeeDetail() {
      if (this.checkedArr.length == 0) {
        this.$toast("请至少选择一个行程");
      } else {
        sessionStorage.setItem("checkedArr", JSON.stringify(this.checkedArr));
        this.$router.push({
          path: "/takingCar/invoiceDetails",
        });
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="less">
.journeyInvoice {
  background: #f5f6f7;
  min-height: 100%;
  .loading {
    width: 40%;
    margin: 0 auto;
    display: flex;
    height: 100%;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .content {
    // margin-top: 70px;
    padding: 85px 15px 80px;
    overflow: scroll;
    height: 100%;
    .van-list {
      margin-bottom: 40px;
      .list {
        background-color: #ffffff;
        border-radius: 5px;
        font-size: 13px;
        line-height: 18px;
        margin-bottom: 15px;
        display: flex;
        flex-direction: row;
        .left {
          width: 16px;
          height: 16px;
          margin: 49px 15px 0;
          background: url(../../assets/takingCar/unchecked.png) no-repeat center
            center;
          background-size: cover;
        }
        .uncheckimg {
          background: url(../../assets/takingCar/unchecked.png) no-repeat center
            center;
          background-size: cover;
        }
        .ncheckimg {
          background: url(../../assets/takingCar/checked.png) no-repeat center
            center;
          background-size: cover;
        }
        .right {
          flex: 1;
          .title {
            color: #333333;
            font-size: 15px;
            margin: 15px 0;
            line-height: 21px;
            font-weight: bolder;
            span {
              color: #666666;
              font-size: 13px;
              line-height: 18px;
              margin-left: 14px;
              font-weight: normal;
            }
          }
          p {
            color: #333333;
            font-size: 13px;
            line-height: 18px;
            img {
              width: 11px;
              height: 11px;
              margin: 0 10px 0 0px;
            }
          }
          .cfd {
            display: flex;
            align-items: center;
            position: relative;
            span {
              flex: 1;
            }
            .middash {
              position: absolute;
              width: 1px;
              height: 11px;
              bottom: -13px;
              left: 5px;
            }
          }
          .mdd {
            margin: 10px 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .mddp {
              display: flex;
              // align-items: center;
              img {
                transform: translateY(8px);
              }
              span {
                flex: 1;
              }
            }
            span {
              font-size: 14px;
              line-height: 28px;
            }
            .mddright {
              margin-right: 15px;
              white-space: nowrap;
              font-weight: bold;
              .money {
                font-size: 20px;
                // font-weight: bold;
              }
            }
          }
        }
      }
      .van-list__finished-text {
        color: #999999;
        font-size: 15px;
        line-height: 21px;
        text-align: center;
        margin-top: 15px;
        margin-bottom: 53px;
      }
    }
  }
  .isIosx {
    margin-top: 90px;
    padding: 15px 15px 80px;
  }
  .foot {
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #f5f6f7;
    .button {
      width: 100%;
      height: 80px;
      background: #ffffff;
      overflow: hidden;
      div {
        float: left;
        width: 17%;
        height: 21px;
        margin-left: 3%;
        margin-top: 29.5px;
        overflow: hidden;
        img {
          float: left;
          width: 16px;
          height: 16px;
          margin-top: 3.5px;
        }
        span {
          float: left;
          margin-left: 8px;
          color: #333333;
          font-size: 15px;
          line-height: 21px;
        }
      }
      button {
        float: left;
        margin-left: 3%;
        margin-top: 15px;
        width: 73%;
        align-items: center;
        background: #181818;
        color: #ffffff;
        font-size: 18px;
        line-height: 25px;
        height: 50px;
        border-radius: 5px;
        border: none;
      }
      .bannedClick {
        background: #e0e0e0;
      }
    }
  }
  .empty {
    text-align: center;
    color: #999999;
    font-size: 17px;
    line-height: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
  }
}
</style>
